import React from 'react';
export function Hero() {
  return <section className="w-full bg-transparent pt-2 pb-4 md:pt-2 md:pb-6" data-id="element-70" data-mp="3q74j56kehpya">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-71" data-mp="ejmot8gadfu8">
        <div className="text-center space-y-2" data-id="element-72" data-mp="ei1v1l1sq0xf">
          <div className="flex justify-center mb-1" data-id="element-73" data-mp="9luz8l3465t7">
            
          </div>

          <h1 className="md:text-5xl lg:text-6xl text-white font-[900] text-[24px] font-[Poppins,_sans-serif]" data-id="element-74" data-mp="4m8kg77n0hia">
            🏆 Tus sesiones resueltas todo el año.
          </h1>

          <div className="flex flex-col items-center pt-1 pb-1" data-id="element-75" data-mp="xae5yw6imaj6">
            <img src="https://cdn.magicpatterns.com/uploads/jrWVixX6Xy4EHrJzY3KJS3/defc85b6-c78f-4e4f-be73-c8bfc8c27bb9.png" alt="PsicoKit Profesional: actividades listas para usar en 6 áreas clave más 6 bonos" className="w-full max-w-3xl h-auto mt-[5px] mb-[5px] pl-[60px] pr-[60px]" data-id="element-76" data-mp="xb5rfe6eervq" />
            <p className="md:text-xl mt-3 tracking-wide font-[700] font-['Open_Sans',_sans-serif] text-[#B794D6] text-[14px]" data-id="element-77" data-mp="3d33gp3txj3ne">
              Más de 800 páginas de actividades, evaluaciones e intervenciones
              listas para usar, organizadas para acompañarte durante todo el
              año.
            </p>
          </div>

          <div className="flex items-center justify-center gap-1.5 pt-2" data-id="element-78" data-mp="3o59a5dwsawbw">
            <span className="text-yellow-400 text-sm" data-id="element-79" data-mp="39a37n0wwdfnb">⭐⭐⭐⭐⭐</span>
            <span className="text-white text-sm font-semibold" data-id="element-80" data-mp="3e8efj63mtg2w">4.9/5</span>
            <span className="text-gray-400 text-xs" data-id="element-81" data-mp="30iayquniueku">
              Mas de 65 profesionales ya adquirieron este megapack hoy
            </span>
          </div>

          <div className="flex justify-center pt-2" data-id="element-82" data-mp="35a2hij0frg0f">
            <a href="#oferta-pro" className="inline-block bg-[#C084FC] hover:bg-[#9333EA] text-white font-bold px-8 py-4 rounded-lg transition-all duration-200 hover:scale-105 font-['Open_Sans',_sans-serif] text-[18px]" data-id="element-83" data-mp="2qkmsp8kgtknd">
              🧮→ ACCEDER AL MATERIAL
            </a>
          </div>

          <div className="flex flex-col items-center gap-2 text-xs md:text-sm text-white pt-2" data-id="element-84" data-mp="2lla4okhuy7j7">
            <div className="flex flex-nowrap justify-center gap-2" data-id="element-85" data-mp="s2jnhxye22k1">
              <span className="flex items-center gap-1.5 border-2 border-[#9333EA] rounded-md px-3 py-1 whitespace-nowrap font-semibold" data-id="element-86" data-mp="s3uqvwnx98am">
                📄 Plantillas listas para usar
              </span>
              <span className="flex items-center gap-1.5 border-2 border-[#9333EA] rounded-md px-3 py-1 whitespace-nowrap font-semibold" data-id="element-87" data-mp="i9vuleaj4iql">
                ⚡ Ahorrá horas de planificación
              </span>
            </div>
            <span className="flex items-center gap-1.5 border-2 border-[#9333EA] rounded-md px-3 py-1 whitespace-nowrap font-semibold" data-id="element-88" data-mp="161az9dps3c50">
              📊 Informes y seguimiento más rápidos
            </span>
          </div>
        </div>
      </div>
    </section>;
}